/**
 * @generated SignedSource<<93215ac2fe0af029a654eeb55ccfc2da>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpHistory_viewer$data = {
  readonly nftItemHistory: {
    readonly events: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly id: string | null;
          readonly timestamp: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistoryItem_nftItemHistoryEvent">;
        } | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      };
    } | null;
  } | null;
  readonly user?: {
    readonly ethereumWalletAddress: {
      readonly address: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NftPdpHistory_viewer";
};
export type NftPdpHistory_viewer$key = {
  readonly " $data"?: NftPdpHistory_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistory_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchUser"
    },
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "itemCount"
    },
    {
      "kind": "RootArgument",
      "name": "nftId"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "itemCount",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "nftItemHistory",
          "events"
        ]
      }
    ]
  },
  "name": "NftPdpHistory_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "nftId"
        }
      ],
      "concreteType": "NftItemHistory",
      "kind": "LinkedField",
      "name": "nftItemHistory",
      "plural": false,
      "selections": [
        {
          "alias": "events",
          "args": null,
          "concreteType": "NftItemHistoryEventsConnection",
          "kind": "LinkedField",
          "name": "__NftPdpHistory_events_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItemHistoryEventsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "timestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NftPdpHistoryItem_nftItemHistoryEvent"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EthereumAddressType",
              "kind": "LinkedField",
              "name": "ethereumWalletAddress",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "address",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "af4d8ef95e3e2ecf50a16973babea204";

export default node;
